import React, { useState } from "react";
import {Outlet, Link, useLocation } from "react-router-dom";
import './Impressum.css';
import Footer from "../components/Footer";

const Impressum = () =>{

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    return(
        <section className="container-impressum"
        style={{ overflow: 'hidden'}}>
            <div className="navbar-impressum"
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/impressum-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
    
                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                    <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                    <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                </nav>
    
                {/* Hexagon Nav (desktop) */}
                <section className="hero--inner">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                </section>
            </div>

            
            <div className="impressum-container"
            style={{
            position: 'relative',
            minHeight: '100%',
            width: '100%',
            backgroundImage: 'url(/assets/impressum-body.png)',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 0,
            }}>
                <h1 className="impressum-heading">Impressum</h1>

                <section className="impressum-section">
                    <h2>Angaben gemäß § 5 TMG</h2>
                    <p>
                    <strong>LAM Autoservice</strong><br />
                    Inhaber: Mohammad Alhussein<br />
                    Schwarzbach 152<br />
                    42277 Wuppertal
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>Kontakt</h2>
                    <p>
                    Telefon: +49 176 72987527<br />
                    E-Mail: <a href="mailto:info@lam-autoservice.de">info@lam-autoservice.de</a>
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>Umsatzsteuer-ID</h2>
                    <p>
                    Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                    <em>DE 365984982</em>
                    </p>
                </section>


                <section className="impressum-section">
                    <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                    <p>
                    Mohammad Alhussein<br />
                    Schwarzbach 152<br />
                    42277 Wuppertal
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>Haftung für Inhalte</h2>
                    <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                    nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter 
                    jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen 
                    oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>Haftung für Links</h2>
                    <p>
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
                    Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                    </p>
                </section>

                <section className="impressum-section">
                    <h2>Urheberrecht</h2>
                    <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
                    Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                    bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                    </p>
                </section>
                </div>
            
                <div className="footer-homepage">
                < Footer />
                </div>
            <Outlet />
         </section>
    );
};

export default Impressum;

/**
 * <div class="hexagon-wrapper">
            <div class="hexagon" id="hexagon-über-uns">
                <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
            </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/kontakt" class="link">Kontakt</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                </div>
            </div>
 */